class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawerContainer = document.querySelector("#cart-drawer-container");

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.debouncedLoadCartEvent = debounce(() => {
      this.fetchCart()
    }, 300);
    this.debouncedOpenCartDrawer = debounce(() => {
        this.handleDrawer(true)
    }, 300);
    this.openCartDrawer = () => {
        this.fetchCart()
        this.handleDrawer(true)
    };
    this.closeCartDrawer = () => {
        this.handleDrawer(false)
    };
    this.forceUpdateCart = (eventData) => {
        this.fetchCart()
        console.log('fetchData => ',eventData)
        this.updateCart(eventData.detail)
    };

    this.addEventListener('change', this.debouncedOnChange.bind(this));
    document.addEventListener('load-drawer-cart', this.debouncedLoadCartEvent.bind(this));
    document.addEventListener('open-cart-drawer-after-add-cart', this.debouncedOpenCartDrawer.bind(this));
    document.addEventListener('open-cart-drawer', this.openCartDrawer.bind(this));
    document.addEventListener('close-cart-drawer', this.closeCartDrawer.bind(this));
    document.addEventListener('card-drawer__cart-updated', event => this.forceUpdateCart.bind(this)(event));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }

  loadingDrawerCart(loadingState) {
    const drawerLoader = document.querySelector('.drawer-cart__loading-cart');
    if (drawerLoader) {
        if (loadingState) {
            document.querySelectorAll('.loading-overlay').forEach(el => {
                el.style.display = 'block';
            })
        } else {
            document.querySelectorAll('.loading-overlay').forEach(el => {
                el.style.display = 'none';
            })
        }
    }
  }

  fetchCart() {
    this.loadingDrawerCart(true)
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
        "attributes": {
            "consentPrefs": {
                "marketing": "",
                "analytics": "",
                "preferences": "",
                "sale_of_data": ""
            }
    }
    });
    fetch(`/cart/update.js`, {
      body, 
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.updateCart(parsedState)
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      })
      .finally(() => {
        this.loadingDrawerCart(false)
      })
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.updateCart(parsedState, name, line)
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateCart(parsedState, name, line) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

      elementToReplace.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));
    if (line) {
      this.updateLiveRegions(line, parsedState.item_count);
      const lineItem =  document.getElementById(`CartItem-${line}`);
      if (name && lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
      this.disableLoading();
    }
    // this.tagDrawerCart()
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML || null;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => {overlay.classList.remove('hidden'); overlay.style.display = null});
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }

  handleDrawer(open) {
    this.cartDrawerContainer.style.display = open ? 'flex' : 'none';
    this.smoothScrollAnnouncementBar();
    // Tag ##cart-drawer-container to shrink the height of the cart-drawer so the address bar does not get in front of
    // the checkout button.
    // this.tagDrawerCart();
  }

  tagDrawerCart() {
    const userAgent = navigator.userAgent
    if(navigator.userAgent.match(/Safari/g) && navigator.userAgent.match(/iPhone/g)) {
      const wrapper =  this.cartDrawerContainer.querySelector('.drawer-cart-footer')
      wrapper.style.paddingBottom = '9rem'
    }
  }

  smoothScrollAnnouncementBar() {
    // Scroll ignoring announcementBar
    var startY = window.scrollY || window.pageYOffset;
    
    const announcementBarHeight = document.querySelector('#shopify-section-announcement-bar')?.offsetHeight;
    if (announcementBarHeight) {
        if (window.pageYOffset < announcementBarHeight) {
            var targetY = startY + (announcementBarHeight || 0);
        
            // Scroll to the target position smoothly
            window.scrollTo({
                top: targetY,
                behavior: 'smooth'
            });
        }
    }
}
}

customElements.define('cart-items', CartItems);
